<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">抄表二维码</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input
          search
          enter-button
          placeholder="搜索序列号/站点/企业"
          v-model="page.key"
          style="width: 400px"
          @on-enter="search"
          @on-search="search"
        />
      </div>
      <div class="right">
        <Button type="primary" @click="printQrCode" style="margin-right: 10px"
          >打印选择二维码</Button
        >
        <Button type="success" @click="showCreateQrCode(false)"
          >创建全新二维码</Button
        >
      </div>
    </div>
    <div style="position: relative">
      <div class="tabBox">
        <div
          class="item"
          :class="{ select: selectTableIndex === 0 }"
          @click="selectTableIndex = 0"
        >
          已绑定二维码
        </div>
        <div
          class="item"
          :class="{ select: selectTableIndex === 1 }"
          @click="selectTableIndex = 1"
        >
          全新二维码
        </div>
      </div>
      <Row v-if="selectTableIndex === 0" id="QrCodePrint" class="row">
        <div
          v-for="(item, key) in list"
          :key="key"
          class="itemBox"
          style="margin-top: 10px"
        >
          <Card>
            <div slot="title">
              <Checkbox v-model="item.select">选择</Checkbox>
              <div class="btns" style="float: right">
                <Button
                  type="primary"
                  style="margin-right: 10px"
                  size="small"
                  @click="showModel(item)"
                  >更改绑定</Button
                >
                <Button type="warning" size="small" @click="remove(item.id, 0)"
                  >解除绑定</Button
                >
              </div>
            </div>
            <div class="contentBox">
              <div
                class="qrcode"
                :ref="`qrcode${item.id}`"
                :id="`qrcode${item.id}`"
              ></div>
              <div class="content">
                <div class="item">
                  <span class="tit">编号：</span>
                  <span class="val">{{ item.code_no }}</span>
                </div>
                <div class="item">
                  <span class="tit">设备类型：</span>
                  <span class="val">{{
                    item.meter === 0
                      ? "云知印"
                      : item.meter === 1
                      ? "智能运维"
                      : "手工抄表"
                  }}</span>
                </div>
                <div class="item">
                  <span class="tit">型号：</span>
                  <span class="val">{{ item.machine_type_name }}</span>
                </div>
                <div class="item">
                  <span class="tit">序列号：</span>
                  <span class="val">{{ item.sn }}</span>
                </div>
                <div class="item">
                  <span class="tit">站点：</span>
                  <span class="val">{{ item.site_name }}</span>
                </div>
                <div class="item">
                  <span class="tit">客户：</span>
                  <span class="val">{{ item.agent_name }}</span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </Row>
      <Row v-if="selectTableIndex === 1" class="row">
        <div
          v-for="(item, key) in list"
          :key="key"
          class="itemBox"
          style="margin-top: 10px"
        >
          <Card>
            <div slot="title">
              <Checkbox v-model="item.select">选择</Checkbox>
              <div class="btns" style="float: right">
                <Button
                  type="primary"
                  style="margin-right: 10px"
                  size="small"
                  @click="showModel(item)"
                  >绑定</Button
                >
                <Button type="warning" size="small" @click="remove(item.id, 1)"
                  >删除</Button
                >
              </div>
            </div>
            <div class="contentBox">
              <div
                class="qrcode"
                :ref="`qrcode${item.id}`"
                :id="`qrcode_new${item.id}`"
              ></div>
              <div class="content">
                <div class="btns"></div>
                <div class="bottom">
                  <p class="txt">编号</p>
                  <p class="num">{{ item.code_no }}</p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </Row>
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Modal
      v-model="modal.status"
      title="选择设备"
      @on-ok="selectMachine"
      width="800"
    >
      <div class="content-header">
        <div class="left">
          <Input
            search
            enter-button
            placeholder="搜索序列号/站点/企业"
            v-model="modal.page.key"
            style="width: 300px"
            @on-enter="searchMachineList"
            @on-search="searchMachineList"
          />
        </div>
      </div>
      <Table :columns="modal.columns" :data="modal.machine">
        <template slot-scope="{ row }" slot="action">
          <Button
            type="primary"
            style="margin-right: 10px"
            size="small"
            @click="selectMachine(row)"
            >绑定</Button
          >
        </template>
      </Table>
      <div slot="footer">
        <div class="t-right">
          <Page
            @on-change="pageChangeMachine"
            @on-page-size-change="sizeChangeMachine"
            :total="modal.page.total"
            show-total
          />
        </div>
      </div>
    </Modal>
    <Modal
      v-model="expire.visible"
      title="填写数量"
      :width="235"
      @on-ok="createQrCode"
    >
      <Input
        v-model="expire.num"
        maxlength="2"
        size="small"
        placeholder="请输入创建二维码数量"
      />
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import config from '../../../config/index'
export default {
  data () {
    return {
      selectTableIndex: 0,
      list: [],
      total: 0,
      loading: false,
      expire: {
        visible: false,
        num: null
      },
      page: {
        p: 0,
        l: 9,
        key: '',
        type: 0
      },
      modal: {
        status: false,
        data: {
          id: 0,
          machine_id: 0
        },
        page: {
          total: 0,
          p: 0,
          l: 10,
          key: ''
        },
        machine: [],
        columns: [
          {
            title: '设备编号',
            key: 'id'
          },
          {
            title: '序列号',
            key: 'sn'
          },
          {
            title: '型号',
            key: 'machine_type_name'
          },
          {
            title: '站点',
            key: 'site_name'
            // render: (h, data) => {
            //   return h("span", {}, data.tp ? "代理商" : "运营商");
            // }
          },
          {
            title: '操作',
            slot: 'action'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['SaveMeterQrcode', 'GetMeterQrCode', 'GetMeterMachineList']),
    initQrcode () {
      this.list.map((item, key) => {
        item.select = false
        try {
          let Dom = document.getElementById(
            this.selectTableIndex === 1
              ? `qrcode_new${item.id}`
              : `qrcode${item.id}`
          )
          Dom.innerHTML = ''
          let qrcode = new QRCode(Dom, {
            text:
              config.baseUrl.pro +
              '/wechat/meterreader/home?code_no=' +
              item.code_no,
            // text: "http://153c459s25.iok.la/wechat/meterreader/home?code_no=" + item.code_no,
            width: 150,
            height: 150,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        } catch (error) {
          console.log(error)
        }
      })
    },
    showCreateQrCode () {
      this.expire.visible = true
      this.expire.num = 1
    },
    createQrCode () {
      this.SaveMeterQrcode({ num: this.expire.num }).then((res) => {
        if (res.status) this.$Message.success('创建全新二维码成功')
        this.page.p = 0
        this.getData()
        this.selectTableIndex = 1
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData () {
      this.list = []
      this.loading = true
      this.GetMeterQrCode(this.page).then((res) => {
        this.loading = false
        this.list = res.data
        this.total = res.total
        setTimeout(() => {
          this.initQrcode()
        }, 300)
      })
    },
    search () {
      this.page.p = 0
      this.getData()
    },
    remove (id, type) {
      let msg = type === 1 ? '删除' : '解除绑定'
      this.$Modal.confirm({
        title: '提示消息',
        content: `<p>${msg}后不可恢复，是否确认解除？</p>`,
        onOk: () => {
          this.SaveMeterQrcode({ id, is_del: 1 }).then((res) => {
            if (res.status) this.$Message.success(`${msg}成功`)
            this.page.p = 0
            this.getData()
          })
        }
      })
    },
    showModel (row) {
      this.modal.status = true
      this.modal.data.id = row.id
      console.log(row)
      this.getMeterMachineList(row.agent_id)
    },
    selectMachine (row) {
      this.modal.data.machine_id = row.id
      this.$Modal.confirm({
        title: '提示消息',
        content: `<p>是否绑定该设备？</p>`,
        onOk: () => {
          this.SaveMeterQrcode(this.modal.data).then((res) => {
            if (res.status) {
              this.modal.status = false
              this.$Message.success(`绑定成功`)
              this.page.p = 0
              this.getData()
            }
          })
        }
      })
    },
    cancel () {
      this.modal.status = false
    },
    getMeterMachineList (agent_id) {
      let data = this.modal.page
      if (agent_id) data.agent_id = agent_id
      this.GetMeterMachineList(data).then((res) => {
        this.modal.machine = res.data
        this.modal.page.total = res.total
      })
    },
    sizeChangeMachine (l) {
      this.modal.page.l = l
      this.getMeterMachineList()
    },
    pageChangeMachine (p) {
      this.modal.page.p = p - 1
      this.getMeterMachineList()
    },
    searchMachineList () {
      this.modal.page.p = 0
      this.getMeterMachineList()
    },
    printQrCode () {
      let ids = []
      this.list.map((item) => {
        if (item.select) ids.push(item.id)
      })
      if (!ids.length) {
        this.$Message.error('请选择要打印的二维码')
        return false
      }
      if (ids.length > 8) {
        this.$Message.error('单次最多打印8个二维码')
        return false
      }
      /*  const { href } = this.$router.resolve({
        path: "/meter-qrcode-print",
        query: { ids: ids.join(","), type: this.page.type }
      }); */

      const href = `${
        config.baseUrl.pro
      }/print/meter/qrcode/print?ids=${ids.join(',')}`
      window.open(href, '_blank')
      /* this.$router.push({
        path: "/meter-qrcode-print",
        query: { ids: ids.join(",") }
      }); */
    }
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({}),
  watch: {
    selectTableIndex (val) {
      this.page.type = val
      this.list = []
      this.page.p = 0
      this.total = 0
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
